// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Toy parade — decorative idle animation along the footer's top line.
 * A He-Man-style scout tiptoes across pausing to check around, then the troupe
 * (plush, Hot-Wheels-style car, toy robot) streams in behind it via staggered
 * per-actor animation-delays set from the orchestrator.
 *
 * Layout: the strip is anchored just above the footer's top border (its bottom
 * edge sits on that line) and clips actors as they enter/exit. Actors cross via
 * \`left\` on the actor element; the walk bob lives on the inner body element so
 * the two transforms never fight. Everything is a flat currentColor silhouette.
 */

.toy-parade-strip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 54px;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  color: rgb(120, 145, 175);
}

.toy-parade-actor {
  position: absolute;
  left: -70px;
  bottom: 0;
  width: 30px;
  height: 42px;
  /* Opaque fill + one group-level alpha, so overlapping silhouette shapes
     flatten to a single solid before the transparency is applied (no dark seams). */
  opacity: 0.32;
  will-change: left;
  animation: toy-parade-cross 20s ease-in-out both;
}

.toy-parade-actor__body {
  width: 100%;
  height: 100%;
  transform-origin: 50% 100%;
}

.toy-parade-actor__body svg {
  display: block;
  width: 100%;
  height: 100%;
}

/* Per-role sizing + gait. The leader tiptoes; followers march/roll behind. */
.toy-parade-actor--leader {
  width: 30px;
  height: 42px;
  /* The hero SVG leaves ~8 units of empty space below its feet inside its own
     viewBox, so at bottom:0 the figure hovers above the line. Drop it so the
     boots plant on the footer line instead of floating. The strip clips the
     now-below-line empty space. */
  bottom: -7px;
  /* Cross the footer while also popping a couple of jumps during the "wave the
     others in" pause (both animations share the 20s cross timeline so the jump
     lands exactly on the signal beat). */
  animation:
    toy-parade-cross 20s ease-in-out both,
    toy-parade-leader-signal 20s ease-in-out both;
}
.toy-parade-actor--leader .toy-parade-actor__body {
  animation: toy-parade-tiptoe 0.6s ease-in-out infinite;
}

.toy-parade-actor--plush {
  width: 26px;
  height: 35px;
}
.toy-parade-actor--plush .toy-parade-actor__body {
  animation: toy-parade-waddle 0.7s ease-in-out infinite;
}

.toy-parade-actor--car {
  width: 40px;
  height: 22px;
}
.toy-parade-actor--car .toy-parade-actor__body {
  animation: toy-parade-jitter 0.35s ease-in-out infinite;
}

.toy-parade-actor--robot {
  width: 27px;
  height: 40px;
}
.toy-parade-actor--robot .toy-parade-actor__body {
  animation: toy-parade-stomp 0.66s steps(2, end) infinite;
}

.toy-parade-actor--dino {
  width: 62px;
  height: 49px;
}
.toy-parade-actor--dino .toy-parade-actor__body {
  animation: toy-parade-lumber 1.1s ease-in-out infinite;
}

/* Horizontal crossing with nervous pauses to "check that nobody is around".
   Followers reuse this exact path (offset by their delay) so the troupe holds
   formation and streams across in a single file behind the leader. */
@keyframes toy-parade-cross {
  0%   { left: -70px; }
  12%  { left: 16%; }
  20%  { left: 16%; }   /* pause — peek around */
  32%  { left: 40%; }
  40%  { left: 40%; }   /* pause — all clear? */
  54%  { left: 62%; }
  62%  { left: 62%; }   /* pause — wave the others in */
  100% { left: calc(100% + 50px); }
}

/* Light-footed bounce so the scout looks like it's creeping on tiptoes. */
@keyframes toy-parade-tiptoe {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50%      { transform: translateY(-3px) rotate(-2deg); }
}

/* Excited little hops during the "wave the others in" pause (54%–62% of the
   shared cross timeline), so the leader visibly signals the troupe. Applied to
   the actor element (which otherwise only animates \`left\`) so it never fights
   the tiptoe bob living on the inner body. */
@keyframes toy-parade-leader-signal {
  0%, 54%   { transform: translateY(0); }
  56.5%     { transform: translateY(-10px); }
  59%       { transform: translateY(0); }
  61.5%     { transform: translateY(-8px); }
  62%, 100% { transform: translateY(0); }
}

/* Soft side-to-side waddle for the plush. */
@keyframes toy-parade-waddle {
  0%, 100% { transform: translateY(0) rotate(-3deg); }
  50%      { transform: translateY(-2px) rotate(3deg); }
}

/* Tiny suspension jitter for the rolling car. */
@keyframes toy-parade-jitter {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-1px); }
}

/* Stiff mechanical stomp for the robot. */
@keyframes toy-parade-stomp {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50%      { transform: translateY(-2px) rotate(1.5deg); }
}

/* Slow, heavy sway for the towering apatosaurus bringing up the rear. */
@keyframes toy-parade-lumber {
  0%, 100% { transform: translateY(0) rotate(-1deg); }
  50%      { transform: translateY(-2px) rotate(1deg); }
}

@media (prefers-reduced-motion: reduce) {
  .toy-parade-strip {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/idle-animation/toy-parade.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ;oFACkF;EAClF,aAAa;EACb,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ;;;kCAGgC;EAChC,YAAY;EACZ;;yCAEuC;EACvC;;iDAE+C;AACjD;AACA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sDAAsD;AACxD;;AAEA;;qEAEqE;AACrE;EACE,OAAO,WAAW,EAAE;EACpB,OAAO,SAAS,EAAE;EAClB,OAAO,SAAS,EAAE,IAAI,wBAAwB;EAC9C,OAAO,SAAS,EAAE;EAClB,OAAO,SAAS,EAAE,IAAI,uBAAuB;EAC7C,OAAO,SAAS,EAAE;EAClB,OAAO,SAAS,EAAE,IAAI,+BAA+B;EACrD,OAAO,uBAAuB,EAAE;AAClC;;AAEA,0EAA0E;AAC1E;EACE,WAAW,qCAAqC,EAAE;EAClD,WAAW,yCAAyC,EAAE;AACxD;;AAEA;;;6CAG6C;AAC7C;EACE,YAAY,wBAAwB,EAAE;EACtC,YAAY,4BAA4B,EAAE;EAC1C,YAAY,wBAAwB,EAAE;EACtC,YAAY,2BAA2B,EAAE;EACzC,YAAY,wBAAwB,EAAE;AACxC;;AAEA,4CAA4C;AAC5C;EACE,WAAW,sCAAsC,EAAE;EACnD,WAAW,wCAAwC,EAAE;AACvD;;AAEA,gDAAgD;AAChD;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,WAAW,qCAAqC,EAAE;EAClD,WAAW,0CAA0C,EAAE;AACzD;;AAEA,wEAAwE;AACxE;EACE,WAAW,sCAAsC,EAAE;EACnD,WAAW,wCAAwC,EAAE;AACvD;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/*\r\n * Toy parade — decorative idle animation along the footer's top line.\r\n * A He-Man-style scout tiptoes across pausing to check around, then the troupe\r\n * (plush, Hot-Wheels-style car, toy robot) streams in behind it via staggered\r\n * per-actor animation-delays set from the orchestrator.\r\n *\r\n * Layout: the strip is anchored just above the footer's top border (its bottom\r\n * edge sits on that line) and clips actors as they enter/exit. Actors cross via\r\n * `left` on the actor element; the walk bob lives on the inner body element so\r\n * the two transforms never fight. Everything is a flat currentColor silhouette.\r\n */\r\n\r\n.toy-parade-strip {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 100%;\r\n  height: 54px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: 0;\r\n  color: rgb(120, 145, 175);\r\n}\r\n\r\n.toy-parade-actor {\r\n  position: absolute;\r\n  left: -70px;\r\n  bottom: 0;\r\n  width: 30px;\r\n  height: 42px;\r\n  /* Opaque fill + one group-level alpha, so overlapping silhouette shapes\r\n     flatten to a single solid before the transparency is applied (no dark seams). */\r\n  opacity: 0.32;\r\n  will-change: left;\r\n  animation: toy-parade-cross 20s ease-in-out both;\r\n}\r\n\r\n.toy-parade-actor__body {\r\n  width: 100%;\r\n  height: 100%;\r\n  transform-origin: 50% 100%;\r\n}\r\n\r\n.toy-parade-actor__body svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Per-role sizing + gait. The leader tiptoes; followers march/roll behind. */\r\n.toy-parade-actor--leader {\r\n  width: 30px;\r\n  height: 42px;\r\n  /* The hero SVG leaves ~8 units of empty space below its feet inside its own\r\n     viewBox, so at bottom:0 the figure hovers above the line. Drop it so the\r\n     boots plant on the footer line instead of floating. The strip clips the\r\n     now-below-line empty space. */\r\n  bottom: -7px;\r\n  /* Cross the footer while also popping a couple of jumps during the \"wave the\r\n     others in\" pause (both animations share the 20s cross timeline so the jump\r\n     lands exactly on the signal beat). */\r\n  animation:\r\n    toy-parade-cross 20s ease-in-out both,\r\n    toy-parade-leader-signal 20s ease-in-out both;\r\n}\r\n.toy-parade-actor--leader .toy-parade-actor__body {\r\n  animation: toy-parade-tiptoe 0.6s ease-in-out infinite;\r\n}\r\n\r\n.toy-parade-actor--plush {\r\n  width: 26px;\r\n  height: 35px;\r\n}\r\n.toy-parade-actor--plush .toy-parade-actor__body {\r\n  animation: toy-parade-waddle 0.7s ease-in-out infinite;\r\n}\r\n\r\n.toy-parade-actor--car {\r\n  width: 40px;\r\n  height: 22px;\r\n}\r\n.toy-parade-actor--car .toy-parade-actor__body {\r\n  animation: toy-parade-jitter 0.35s ease-in-out infinite;\r\n}\r\n\r\n.toy-parade-actor--robot {\r\n  width: 27px;\r\n  height: 40px;\r\n}\r\n.toy-parade-actor--robot .toy-parade-actor__body {\r\n  animation: toy-parade-stomp 0.66s steps(2, end) infinite;\r\n}\r\n\r\n.toy-parade-actor--dino {\r\n  width: 62px;\r\n  height: 49px;\r\n}\r\n.toy-parade-actor--dino .toy-parade-actor__body {\r\n  animation: toy-parade-lumber 1.1s ease-in-out infinite;\r\n}\r\n\r\n/* Horizontal crossing with nervous pauses to \"check that nobody is around\".\r\n   Followers reuse this exact path (offset by their delay) so the troupe holds\r\n   formation and streams across in a single file behind the leader. */\r\n@keyframes toy-parade-cross {\r\n  0%   { left: -70px; }\r\n  12%  { left: 16%; }\r\n  20%  { left: 16%; }   /* pause — peek around */\r\n  32%  { left: 40%; }\r\n  40%  { left: 40%; }   /* pause — all clear? */\r\n  54%  { left: 62%; }\r\n  62%  { left: 62%; }   /* pause — wave the others in */\r\n  100% { left: calc(100% + 50px); }\r\n}\r\n\r\n/* Light-footed bounce so the scout looks like it's creeping on tiptoes. */\r\n@keyframes toy-parade-tiptoe {\r\n  0%, 100% { transform: translateY(0) rotate(0deg); }\r\n  50%      { transform: translateY(-3px) rotate(-2deg); }\r\n}\r\n\r\n/* Excited little hops during the \"wave the others in\" pause (54%–62% of the\r\n   shared cross timeline), so the leader visibly signals the troupe. Applied to\r\n   the actor element (which otherwise only animates `left`) so it never fights\r\n   the tiptoe bob living on the inner body. */\r\n@keyframes toy-parade-leader-signal {\r\n  0%, 54%   { transform: translateY(0); }\r\n  56.5%     { transform: translateY(-10px); }\r\n  59%       { transform: translateY(0); }\r\n  61.5%     { transform: translateY(-8px); }\r\n  62%, 100% { transform: translateY(0); }\r\n}\r\n\r\n/* Soft side-to-side waddle for the plush. */\r\n@keyframes toy-parade-waddle {\r\n  0%, 100% { transform: translateY(0) rotate(-3deg); }\r\n  50%      { transform: translateY(-2px) rotate(3deg); }\r\n}\r\n\r\n/* Tiny suspension jitter for the rolling car. */\r\n@keyframes toy-parade-jitter {\r\n  0%, 100% { transform: translateY(0); }\r\n  50%      { transform: translateY(-1px); }\r\n}\r\n\r\n/* Stiff mechanical stomp for the robot. */\r\n@keyframes toy-parade-stomp {\r\n  0%, 100% { transform: translateY(0) rotate(0deg); }\r\n  50%      { transform: translateY(-2px) rotate(1.5deg); }\r\n}\r\n\r\n/* Slow, heavy sway for the towering apatosaurus bringing up the rear. */\r\n@keyframes toy-parade-lumber {\r\n  0%, 100% { transform: translateY(0) rotate(-1deg); }\r\n  50%      { transform: translateY(-2px) rotate(1deg); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .toy-parade-strip {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
